function selectedHelpString(bits, strs) {
  for (let i = 0; i < bits.length; i++) {
    if (bits[i]) {
      return strs[i];
    }
  }
  return '';
}

export default function urlModifier() {
  let mod = '';
  // react
  const loc = window.location.hash.substring(2);
  // angular
  const pat = window.location.pathname.substring(1);
  const lang = window.activeUser.language;

  //we only have 3 custom helps the others all use english
  //de-de help appears to be just a shell with no/little content

  const englishEquivalent = lang !== 'fr-ca' && lang !== 'fr-fr'; // && lang !== 'de-de'; PUT THIS back in when we get good german help https://communicationscloud-de.knowledgeowl.com/help

  const frFr = lang === 'fr-fr';
  const frCa = lang === 'fr-ca';
  const deDe = lang === 'de-de';
  const langFlags = [englishEquivalent, frFr, frCa, deDe];

  switch (true) {
    //Coverage
    case loc === 'earned-searches':
      mod = selectedHelpString(langFlags, [
        '/searches', //eng
        '/gestion-des-recherches', //fr-fr
        '/recherche', //fr-ca
        '/wie-die-medienbeobachtung-funktioniert', //de-de
      ]);
      break;

    case loc === 'tags':
      mod = selectedHelpString(langFlags, [
        '/creating-tags', //eng
        '/crer-des-tags', //fr-fr
        '/comment-creer-des-etiquettes', //fr-ca
        '/news-monitoring', //de-de
      ]);
      break;

    case loc.indexOf('earned-searches/advanced') === 0:
      mod = selectedHelpString(langFlags, [
        '/boolean-reference-guides', //eng
        '/crer-une-recherche-de-surveillance', //fr-fr
        '/guides-de-reference-booleens', //fr-ca
        '/news-monitoring', //de-de
      ]);
      break;

    case loc.indexOf('earned-searches/simple') === 0:
      mod = selectedHelpString(langFlags, [
        '/simple-earned-search', //eng
        '/recherche-simple', //fr-fr
        '/recherche-simple-pour-les-medias-acquis', //fr-ca
        '/news-monitoring', //de-de
      ]);
      break;

    case loc.indexOf('browse/top-content') === 0:
      mod = selectedHelpString(langFlags, [
        '/coverage', //eng
        '/news', //fr-fr
        '/couverture-surveillance-des-medias', //fr-ca
        '/news-monitoring', //de-de
      ]);
      break;

    // Influencers
    case loc.indexOf('contacts') === 0:
      mod = selectedHelpString(langFlags, [
        '/identifying-influencers', //eng
        '/identifier-les-influenceurs', //fr-fr
        '', //fr-ca
        '/influencer-datenbank', //de-de
      ]);
      break;

    // Contacts
    //search
    case loc === 'influencers':
      mod = selectedHelpString(langFlags, [
        '/connect-search', //eng
        '/cision-connect', //fr-fr
        '/contact-connect-base-de-donnees', //fr-ca
        '/connect', //de-de
      ]);
      break;

    //Lists
    case loc === 'influencers/saved-lists':
      mod = selectedHelpString(langFlags, [
        '/connect-building-media-lists', //eng
        '/cision-connect', //fr-fr
        '/connect-batir-des-listes', //fr-ca
        '/connect', //de-de
      ]);
      break;

    //Message Center
    case loc === 'influencers/messages/all':
      mod = selectedHelpString(langFlags, [
        '/connect-message-center', //eng
        '/cision-connect', //fr-fr
        '/connect-envoyer-des-courriels', //fr-ca
        '/connect', //de-de
      ]);
      break;

    //Editorial Calendars
    case loc === 'influencers/opportunity-feed/editorial-calendars':
      mod = selectedHelpString(langFlags, [
        '/editorial-calendars', //eng
        '/cision-connect', //fr-fr
        '/recherche-calendriers-redactionnels-avec-connect', //fr-ca
        '/connect', //de-de
      ]);
      break;

    //Media Requests
    case loc === 'influencers/opportunity-feed/media-requests':
      mod = selectedHelpString(langFlags, [
        '/media-requests-with-connect-overview', //eng
        '/cision-connect', //fr-fr
        '/survol-des-demandes-des-medias-avec-connect', //fr-ca
        '/influencer-datenbank', //de-de
      ]);
      break;

    //Ananlytics
    //V2
    case loc === 'dashboard':
      mod = selectedHelpString(langFlags, [
        '/new-dashboards', //eng
        '/tableaux-de-bord-20', //fr-fr
        '/utiliser-les-tableaux-de-bord', //fr-ca
        '/reports-und-dashboards', //de-de
      ]);
      break;

    case loc.indexOf('dashboard') === 0:
      mod = selectedHelpString(langFlags, [
        '/analyze-news-with-new-dashboards', //eng
        '/tableaux-de-bord-20', //fr-fr
        '/utiliser-les-tableaux-de-bord', //fr-ca
        '/reports-und-dashboards', //de-de
      ]);
      break;

    //V1
    case pat === 'dashboard':
      mod = selectedHelpString(langFlags, [
        '/search?phrase=dashboards&Search=', //eng
        '/prsentation-des-tableaux-de-bords-danalyses', //fr-fr
        '/search?phrase=tableau&Search=', //fr-ca
        '', //de-de
      ]);
      break;

    case loc === 'impact/earned':
      mod = selectedHelpString(langFlags, [
        '/earned-impact-next-generation-cision-comms-cloud-', //eng
        '/mesure-de-limpact-du-earned-media', //fr-fr
        '/mesures-impact-pour-les-medias-acquis', //fr-ca
        '/earned-impact', //de-de
      ]);
      break;

    case loc.indexOf('campaigns') === 0:
      mod = selectedHelpString(langFlags, [
        '/campaign-overview-page', //eng
        '/vue-densemble-des-campagnes', //fr-fr
        '/utiliser-campagnes-pour-organiser-les-ressources-de-la-plateforme', //fr-ca
        '', //de-de
      ]);
      break;

    case loc.indexOf('stories') === 0:
      mod = selectedHelpString(langFlags, [
        '/story-kit', //eng
        '/stories', //fr-fr
        '/trousse-thematique', //fr-ca
        '/das-story-kit', //de-de
      ]);
      break;

    case loc.indexOf('report') === 0:
      mod = selectedHelpString(langFlags, [
        '/creating-reports-with-new-dashboards', //eng
        '/rapports-sur-les-news', //fr-fr
        '/crer-des-rapports-avec-les-tableaux-de-bord', //fr-ca
        '/reporting-der-berichterstattung', //de-de
      ]);
      break;

    case loc === 'digest/home':
      mod = selectedHelpString(langFlags, [
        '/creating-an-automated-news-alert-digests', //eng
        '/crer-une-alerte-automatise-par-e-mail', //fr-fr
        '/creation-d-une-alerte-courriel-automatisee-resumes', //fr-ca
        '', //de-de
      ]);
      break;

    case loc === 'alerts/newsletter':
      mod = selectedHelpString(langFlags, [
        '/newsletters', //eng
        '/newsletters', //fr-fr
        '/revues-de-presse', //fr-ca
        '/newsletter-ueberblick', //de-de
      ]);
      break;
    case loc.endsWith('newsletter/add'):
      mod = selectedHelpString(langFlags, [
        '/creating-newsletters', //eng
        '/newsletters', //fr-fr
        '/creer-une-revue-de-presse', //fr-ca
        '/newsletter-ueberblick', //de-de
      ]);
      break;
    case loc.includes('newsletter/edit/'):
      mod = selectedHelpString(langFlags, [
        '/newsletters', //eng
        '/newsletters', //fr-fr
        '/revues-de-presse', //fr-ca
        '/newsletter-ueberblick', //de-de
      ]);
      break;
    case loc === 'social-listening':
      mod = selectedHelpString(langFlags, [
        '/cision-social-listening-powered-by-brandwatch-csl', //eng
        '/prsentation-de-la-surveillance-mdias-sociaux', //fr-fr
        '/csl-alimente-par-brandwatch', //fr-ca
        '', //de-de
      ]);
      break;

    case loc === 'settings/account/integrations':
    case loc === 'settings/manage':
    case loc === 'settings/user-groups':
      mod = selectedHelpString(langFlags, [
        '/user-management', //eng
        '/gestion-des-utilisateurs', //fr-fr
        '/gestion-des-utilisateurs', //fr-ca
        '/nutzer-management', //de-de
      ]);
      break;

    case loc === 'settings/account/mail':
      mod = selectedHelpString(langFlags, [
        '/integration-instructions', //eng
        '/intgrations', //fr-fr
        '/tape-2-intgration-de-votre-courriel-dans-la-plateforme', //fr-ca
        '', //de-de
      ]);
      break;
  }
  return mod;
}
